import type { AIPrompt } from '@/services/admin-api';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@/components/ui/table';

interface PromptVersionsTableProps {
  versions: AIPrompt[];
  onActivate: (version: number) => void;
  onDelete: (version: number) => void;
  activatingVersion: number | null;
  deletingVersion: number | null;
}

export function PromptVersionsTable({
  versions,
  onActivate,
  onDelete,
  activatingVersion,
  deletingVersion,
}: PromptVersionsTableProps) {
  const sorted = [...versions].sort((a, b) => b.version - a.version);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Version</TableHead>
          <TableHead>Provider</TableHead>
          <TableHead>Model</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Created</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {sorted.map((v) => (
          <TableRow key={v.version} className={v.isActive ? 'bg-green-50' : ''}>
            <TableCell className="font-medium">v{v.version}</TableCell>
            <TableCell className="text-muted-foreground">{v.providerId}</TableCell>
            <TableCell className="font-mono text-muted-foreground">{v.model}</TableCell>
            <TableCell>
              {v.isActive ? (
                <Badge variant="success">Active</Badge>
              ) : (
                <span className="text-muted-foreground">Inactive</span>
              )}
            </TableCell>
            <TableCell className="text-muted-foreground">
              {new Date(v.createdAt).toLocaleDateString()}
            </TableCell>
            <TableCell className="text-right space-x-2">
              {!v.isActive && (
                <>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onActivate(v.version)}
                    disabled={activatingVersion === v.version}
                  >
                    {activatingVersion === v.version ? 'Activating...' : 'Activate'}
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onDelete(v.version)}
                    disabled={deletingVersion === v.version}
                    className="text-red-600 hover:text-red-700"
                  >
                    {deletingVersion === v.version ? 'Deleting...' : 'Delete'}
                  </Button>
                </>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
